import { type ActionType, type FilterCondition } from './FilterCondition'

//  Engagement
export const EngagementScoreBounce = 0
export const EngagementScoreNew = 1
export const EngagementScoreInactive = 2
export const EngagementScoreLessActive = 3
export const EngagementScoreActive = 4
export const EngagementScoreVeryActive = 5
export const EngagementScoreExcluded = 6

export type EngagementScore = 0 | 1 | 2 | 3 | 4 | 5 | 6

export interface PagedList<T> {
  Items: T[]
  PageCount: number
  PageSize: number
  PageNumber: number
  TotalItems: number
}

export interface FilterSummary {
  IdList: number
  Name: string
  Description: string
  CustomDescription?: boolean
  Notes?: string
  Hidden: boolean
  Category?: Category
  UpdateDate: string
  Type: FilterType
  Id: number
  Locked: boolean
}

export interface BeFilterSummaryResponse {
  IdList: number
  Name: string
  Description: string
  CustomDescription: boolean
  Hidden: boolean
  Category: number
  UpdateDate: string
  Type: FilterType
  Id: number
  Locked: boolean
}

export enum FilterType {
  Anagraphic = 'Anagraphic',
  Activity = 'Activity',
  Device = 'Device',
  Geolocation = 'Geolocation',
  MultiFilter = 'MultiFilter',
  MultiType = 'MultiType',
  Engagement = 'Engagement',
  Tracking = 'Tracking',
}

export interface Category {
  Id: number
  Name: string
}

export interface CommonPagedListQuery {
  pageSize?: number
  pageNumber?: number
  orderBy?: string
  orderDescending?: boolean
}

interface FilterOnlyQuery {
  search: string
  categories: number[]
  types: FilterType[]
  hidden?: boolean
}

export type FilterPagedListQuery = CommonPagedListQuery & FilterOnlyQuery

export type CategoryPagedListQuery = CommonPagedListQuery & { name: string }

export interface FilterDetail {
  IdList: number
  Name: string
  Description: string
  Notes?: string
  CustomDescription?: boolean
  Hidden: boolean
  Category: number
  UpdateDate: string
  Type: FilterType
  Blocks: Block[]
  Id: number
  Locked: boolean
}

export type FilterRequest = Omit<
  FilterDetail,
  'Id' | 'Locked' | 'Type' | 'Description' | 'CustomDescription'
>
// Type and Description calculated by BE.
// CustomDescription is deprecated and will be removed

export interface Block {
  JoinType: ActionType
  Conditions: FilterCondition[]
}

export interface CheckCategoryUsage {
  IdList: number
  IdFilter: number
  Name: string
}

export interface CheckCategoryNameRequest {
  Name: string
  IdToExclude?: number
}

//
export interface EntityOut {
  Id: number
  IdList: number
  Name: string
  Type: 'Trigger' | 'DynamicContent' | 'Workflow'
}
